
import { WorldCity } from '../types';

// Expansión adicional de Sudáfrica - 70 ciudades más
export const southAfricaAdditionalCities2: WorldCity[] = [
  { name: 'Durban', slug: 'durban', population: 3120282 },
  { name: 'Johannesburg', slug: 'johannesburg', population: 4434827 },
  { name: 'Soweto', slug: 'soweto', population: 1271628 },
  { name: 'Pretoria', slug: 'pretoria', population: 741651 },
  { name: 'Port Elizabeth', slug: 'port-elizabeth', population: 967677 },
  { name: 'Pietermaritzburg', slug: 'pietermaritzburg', population: 475238 },
  { name: 'Benoni', slug: 'benoni', population: 654509 },
  { name: 'Tembisa', slug: 'tembisa', population: 511655 },
  { name: 'East London', slug: 'east-london', population: 267007 },
  { name: 'Vereeniging', slug: 'vereeniging', population: 377922 },
  { name: 'Bloemfontein', slug: 'bloemfontein', population: 256185 },
  { name: 'Boksburg', slug: 'boksburg', population: 445168 },
  { name: 'Welkom', slug: 'welkom', population: 58491 },
  { name: 'Newcastle', slug: 'newcastle', population: 56144 },
  { name: 'Krugersdorp', slug: 'krugersdorp', population: 378821 },
  { name: 'Diepsloot', slug: 'diepsloot', population: 138329 },
  { name: 'Pinetown', slug: 'pinetown', population: 113718 },
  { name: 'Roodepoort', slug: 'roodepoort', population: 368738 },
  { name: 'Witbank', slug: 'witbank', population: 262491 },
  { name: 'Brakpan', slug: 'brakpan', population: 346735 },
  { name: 'Richards Bay', slug: 'richards-bay', population: 57386 },
  { name: 'Vanderbijlpark', slug: 'vanderbijlpark', population: 95840 },
  { name: 'Centurion', slug: 'centurion', population: 236580 },
  { name: 'Uitenhage', slug: 'uitenhage', population: 228912 },
  { name: 'Midrand', slug: 'midrand', population: 84665 },
  { name: 'Nelspruit', slug: 'nelspruit', population: 58672 },
  { name: 'Klerksdorp', slug: 'klerksdorp', population: 178921 },
  { name: 'Springs', slug: 'springs', population: 162072 },
  { name: 'Potchefstroom', slug: 'potchefstroom', population: 128357 },
  { name: 'Carletonville', slug: 'carletonville', population: 52482 },
  { name: 'Rustenburg', slug: 'rustenburg', population: 124824 },
  { name: 'Nigel', slug: 'nigel', population: 39409 },
  { name: 'Kimberley', slug: 'kimberley', population: 225160 },
  { name: 'Polokwane', slug: 'polokwane', population: 130028 },
  { name: 'Paarl', slug: 'paarl', population: 112045 },
  { name: 'Stellenbosch', slug: 'stellenbosch', population: 77476 },
  { name: 'George', slug: 'george', population: 203253 },
  { name: 'Worcester', slug: 'worcester', population: 97821 },
  { name: 'Somerset West', slug: 'somerset-west', population: 129142 },
  { name: 'Hermanus', slug: 'hermanus', population: 19760 },
  { name: 'Mossel Bay', slug: 'mossel-bay', population: 89744 },
  { name: 'Oudtshoorn', slug: 'oudtshoorn', population: 59329 },
  { name: 'Beaufort West', slug: 'beaufort-west', population: 37762 },
  { name: 'Swellendam', slug: 'swellendam', population: 12073 },
  { name: 'Caledon', slug: 'caledon', population: 12847 },
  { name: 'Bredasdorp', slug: 'bredasdorp', population: 15329 },
  { name: 'Malmesbury', slug: 'malmesbury', population: 36654 },
  { name: 'Wellington', slug: 'wellington', population: 58914 },
  { name: 'Ceres', slug: 'ceres', population: 46251 },
  { name: 'Tulbagh', slug: 'tulbagh', population: 4563 },
  { name: 'Grabouw', slug: 'grabouw', population: 4673 },
  { name: 'Elgin', slug: 'elgin', population: 2764 },
  { name: 'Villiersdorp', slug: 'villiersdorp', population: 7881 },
  { name: 'Montagu', slug: 'montagu', population: 13750 },
  { name: 'Ashton', slug: 'ashton', population: 9009 },
  { name: 'Robertson', slug: 'robertson', population: 24295 },
  { name: 'Rawsonville', slug: 'rawsonville', population: 4500 },
  { name: 'Bonnievale', slug: 'bonnievale', population: 14804 },
  { name: 'McGregor', slug: 'mcgregor', population: 1821 },
  { name: 'Greyton', slug: 'greyton', population: 2418 },
  { name: 'Riviersonderend', slug: 'riviersonderend', population: 3650 },
  { name: 'Napier', slug: 'napier', population: 5842 },
  { name: 'Arniston', slug: 'arniston', population: 2500 },
  { name: 'Agulhas', slug: 'agulhas', population: 875 },
  { name: 'Struisbaai', slug: 'struisbaai', population: 1250 },
  { name: 'Hermanus', slug: 'hermanus-alt', population: 19760 },
  { name: 'Gansbaai', slug: 'gansbaai', population: 9248 },
  { name: 'Stanford', slug: 'stanford', population: 4072 },
  { name: 'Betty\'s Bay', slug: 'bettys-bay', population: 1626 },
  { name: 'Kleinmond', slug: 'kleinmond', population: 6968 },
  { name: 'Gordon\'s Bay', slug: 'gordons-bay', population: 15048 },
  { name: 'Strand', slug: 'strand', population: 50054 }
];

export const southAfricaExpanded2 = {
  code: 'ZA',
  name: 'South Africa',
  slug: 'south-africa',
  population: 59308690,
  topCities: [
    { name: 'Cape Town', slug: 'cape-town', population: 4618000 },
    ...southAfricaAdditionalCities2
  ]
};
